/* Generated. This file cannot be edited directly. Please check codegen.ts for configuration. */
// @ts-nocheck

import * as Apollo from '@apollo/client'

import { gql } from '@apollo/client'
import * as Types from '../../../../../graphql/src/lib/graphql/generated/types'

const defaultOptions = {} as const
export type CallButtonVehicleFragment = { __typename?: 'Vehicle'; id: string }

export type FccGetPhoneNumbersQueryVariables = Types.Exact<{
  vehicleId: Types.Scalars['ID']['input']
}>

export type FccGetPhoneNumbersQuery = {
  __typename?: 'Query'
  fccPhoneNumbers: Array<{
    __typename?: 'FccPhone'
    phoneNumber: string
    type: Types.FccPhoneType
  }>
}

export const CallButtonVehicleFragmentDoc = gql`
    fragment CallButtonVehicle on Vehicle {
  id
}
    `
export const FccGetPhoneNumbersDocument = gql`
    query fccGetPhoneNumbers($vehicleId: ID!) {
  fccPhoneNumbers(vehicleId: $vehicleId) {
    phoneNumber
    type
  }
}
    `

/**
 * __useFccGetPhoneNumbersQuery__
 *
 * To run a query within a React component, call `useFccGetPhoneNumbersQuery` and pass it any options that fit your needs.
 * When your component renders, `useFccGetPhoneNumbersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFccGetPhoneNumbersQuery({
 *   variables: {
 *      vehicleId: // value for 'vehicleId'
 *   },
 * });
 */
export function useFccGetPhoneNumbersQuery(
  baseOptions: Apollo.QueryHookOptions<
    FccGetPhoneNumbersQuery,
    FccGetPhoneNumbersQueryVariables
  > &
    (
      | { variables: FccGetPhoneNumbersQueryVariables; skip?: boolean }
      | { skip: boolean }
    ),
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<
    FccGetPhoneNumbersQuery,
    FccGetPhoneNumbersQueryVariables
  >(FccGetPhoneNumbersDocument, options)
}
export function useFccGetPhoneNumbersLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    FccGetPhoneNumbersQuery,
    FccGetPhoneNumbersQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<
    FccGetPhoneNumbersQuery,
    FccGetPhoneNumbersQueryVariables
  >(FccGetPhoneNumbersDocument, options)
}
export function useFccGetPhoneNumbersSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        FccGetPhoneNumbersQuery,
        FccGetPhoneNumbersQueryVariables
      >,
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions }
  return Apollo.useSuspenseQuery<
    FccGetPhoneNumbersQuery,
    FccGetPhoneNumbersQueryVariables
  >(FccGetPhoneNumbersDocument, options)
}
export type FccGetPhoneNumbersQueryHookResult = ReturnType<
  typeof useFccGetPhoneNumbersQuery
>
export type FccGetPhoneNumbersLazyQueryHookResult = ReturnType<
  typeof useFccGetPhoneNumbersLazyQuery
>
export type FccGetPhoneNumbersSuspenseQueryHookResult = ReturnType<
  typeof useFccGetPhoneNumbersSuspenseQuery
>
export type FccGetPhoneNumbersQueryResult = Apollo.QueryResult<
  FccGetPhoneNumbersQuery,
  FccGetPhoneNumbersQueryVariables
>
